import { lazy, Suspense } from "react";
import { Routes as DomRoutes, Route } from "react-router-dom";
import useScreenList from "src/common/hooks/useScreenList";

export function Routes() {
  const { data: screenList } = useScreenList();

  return (
    <DomRoutes>
      {/* <Route element={<MainRoutePage />}>
      </Route> */}
      {/* {screenList
        .filter((route) => route.withAuthorization)
        .map(({ path, filePath }) => {
          const Component = lazy(() => import(`src/pages${filePath}`));
          return (
            <Route
              key={path}
              path={path}
              element={
                <Suspense>
                  <PrivateRoute component={<Component />} />
                </Suspense>
              }
            />
          );
        })} */}

      {screenList
        .filter((route) => !route.withAuthorization)
        .map(({ path, filePath }) => {
          const Component = lazy(() => import(`src/pages${filePath}`));
          return (
            <Route
              key={path}
              path={path}
              element={
                <Suspense>
                  <Component />
                </Suspense>
              }
            />
          );
        })}
      {/* <Route path="*" element={<div>존재하지 않는 페이지입니다.</div>} /> */}
    </DomRoutes>
  );
}
